import BaseBlock from "./BaseBlock";
import EqualHeightCardCollection from "@/ts/base/Components/EqualHeightCardCollection";
import Waypoint from "@/ts/base/Utils/Waypoint";
import ElementRevealer from "@/ts/base/Utils/ElementRevealer";

class Cards extends BaseBlock {

	protected collection!: EqualHeightCardCollection;
	protected revealer!: ElementRevealer;
	protected cards!: NodeListOf<HTMLElement>;

	public init(): void {
		this.collection = new EqualHeightCardCollection(<HTMLElement>this.block, true);
		this.cards = <NodeListOf<HTMLElement>>this.block.querySelectorAll(this.collection.getSelector());
		this.revealer = new ElementRevealer(this.cards);

		if (this.isAnimated) {
			this.collection.afterMatchHeight = () => {
				this.revealer.run();
				this.cards.forEach(card => {
					card.addEventListener(Waypoint.InViewClass, this.onCardInView.bind(this));
				});
			}
		}
	}

	protected onCardInView(e: Event): void {
		this.revealer.run();
	}
}

export default Cards;
